import React, { FC } from 'react'

import { getJobsPortalUrl } from 'utils/urls'
import { SvgIcon } from 'components/icon'
import { Button, GridContainer } from 'components/ui-kit'

import styles from './CreateAccountFooter.module.scss'

interface Props {
  isValid: boolean
  isPending: boolean
  handleCreateAccount: () => void
}

export const CreateAccountFooter: FC<Props> = ({ handleCreateAccount, isValid, isPending }) => (
  <div className={styles.createAccountFooter}>
    <GridContainer>
      <div className={styles.footerContainer}>
        <a href={getJobsPortalUrl()}>
          <SvgIcon name="go-back-to" />
          <span>Go Back to Jobs Portal</span>
        </a>
        <span className={styles.createAccountBtn}>
          <Button type="primary" disabled={!isValid} pending={isPending} onClick={handleCreateAccount}>
            Create Account
          </Button>
        </span>
      </div>
    </GridContainer>
  </div>
)
